import {GridBox} from '@esgi/ui/layout';
import {styled} from '@esgi/ui/theme';

export const EmptyContentContainer = styled(GridBox, {
	width: '100%',
	height: '100%',
});
